import { AxiosResponse } from "axios";
import { SET_CONTACT_TAGS, SET_CONTACT_TAG, SET_ERRORMSG } from "@/store/mutation-types";
import {
  CLEAR_CONTACT_TAG_ISLOADING,
  DELETE_CONTACT_TAG,
  GET_CONTACT_TAGS,
  REGISTER_CONTACT_TAG,
} from "@/store/action-types";
import { StateObject } from "@/dtos/State.dto";
import ContactTag from "@/services/contact/contact-tag";
import { Module } from "vuex";
import { RegisterContactTag, GetContactTag } from "@/dtos/ContactTag.dto";

const contactTag: Module<any, {}> = {
  state: {
    contactTag: {
      data: null,
      isLoading: false,
    },
    contactTags: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    contactTag: (state: { contactTag: any }) => state.contactTag,
    contactTags: (state: { contactTags: any }) => state.contactTags,
  },
  mutations: {
    [SET_CONTACT_TAG]: (
      state: { contactTag: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.contactTag.data = payload.data;
      state.contactTag.isLoading = payload.isLoading;
    },
    [SET_CONTACT_TAGS]: (
      state: { contactTags: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.contactTags.data = payload.data;
      state.contactTags.isLoading = payload.isLoading;
    },
  },
  actions: {
    [REGISTER_CONTACT_TAG]: async ({ commit }: any, payload: any) => {
      commit(SET_CONTACT_TAG, { data: null, isLoading: true });

      const result: AxiosResponse = await ContactTag.registerContactTag(
        payload as RegisterContactTag
      );

      if (result) {
        if (result.data.status) {
          commit(SET_CONTACT_TAG, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_CONTACT_TAG, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_CONTACT_TAG, { isLoading: false });
        return false;
      }
    },
    [GET_CONTACT_TAGS]: async ({ commit }: any, payload: any) => {
      commit(SET_CONTACT_TAGS, { data: null, isLoading: true });

      const result: AxiosResponse = await ContactTag.getContactTags(payload as GetContactTag);

      if (result) {
        if (result.data.status) {
          commit(SET_CONTACT_TAGS, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }
        commit(SET_CONTACT_TAGS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_CONTACT_TAGS, { isLoading: false });
        return false;
      }
    },
    [DELETE_CONTACT_TAG]: async ({ commit }: any, payload: string) => {
      commit(SET_CONTACT_TAG, { data: { id: payload }, isLoading: true });

      const result: AxiosResponse = await ContactTag.deleteContactTag(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_CONTACT_TAG, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_CONTACT_TAG, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_CONTACT_TAG, { isLoading: false });
        return false;
      }
    },
    [CLEAR_CONTACT_TAG_ISLOADING]: ({ commit }) => {
      commit(SET_CONTACT_TAG, { isLoading: false });
      commit(SET_CONTACT_TAGS, { isLoading: false });
    },
  },
};

export default contactTag;
